export default "__VITE_ASSET__SOcnemx1__"